module.exports = __webpack_public_path__ + "images/suitbag-small.8c461e44cf1d4c40c3db395d713e96db.png";